import React, { useState } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'axios';
import CBMediaQuery from '../../shared/CBMediaQuery';
import '../../../App.css';
import { toast } from 'react-toastify';
import moment from 'moment';

import { getStyle, formatDate, getCurrentCompany, finnishDateFormat } from '../../../utils/utils';
import CBModal from '../../shared/CBModal';
import OeDynamicForm from './OeDynamicForm';
import CBLabelAndValueBlack from '../../shared/CBLabelAndValueBlack';
import CBDatePickerInput from '../../shared/CBDatePickerInput';
import CBInputField from '../../shared/form_components/CBInputField';

const MaintenanceInfoBox = ({ maintenance, t }) => {
  const styles = {
    container: {
      backgroundColor: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '4px',
      padding: '16px',
      marginBottom: '20px',
    },
    title: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#495057',
      marginBottom: '12px',
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      marginRight: '8px',
      color: '#6c757d',
    },
    section: {
      marginBottom: '12px',
    },
    sectionTitle: {
      fontSize: '12px',
      fontWeight: 'bold',
      color: '#6c757d',
      marginBottom: '4px',
    },
    list: {
      margin: 0,
      paddingLeft: '20px',
    },
    listItem: {
      fontSize: '12px',
      color: '#495057',
      marginBottom: '4px',
    },
    partItem: {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: '12px',
      color: '#495057',
      marginBottom: '4px',
    },
    noteItem: {
      fontSize: '12px',
      color: '#495057',
      marginBottom: '4px',
      fontStyle: 'italic',
    },
    description: {
      fontSize: '12px',
      color: '#495057',
      marginBottom: '16px',
      fontStyle: 'italic',
    },
    personnelItem: {
      fontSize: '12px',
      color: '#495057',
      marginBottom: '4px',
      display: 'flex',
      justifyContent: 'space-between',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.title}>
        <i className="pi pi-info-circle" style={styles.icon} />
        {t('maintenanceInfoTitle')}
      </div>
      <p style={styles.description}>
        {t('maintenanceInfoDescription')}
      </p>

      {maintenance.parts && maintenance.parts.length > 0 && (
        <div style={styles.section}>
          <div style={styles.sectionTitle}>{t('parts')}</div>
          <ul style={styles.list}>
            {maintenance.parts.map(part => (
              <li key={part.id} style={styles.partItem}>
                <span>{part.name}</span>
                <span>{part.amount} {part.unit}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {maintenance.tasks && maintenance.tasks.length > 0 && (
        <div style={styles.section}>
          <div style={styles.sectionTitle}>{t('tasks')}</div>
          <ul style={styles.list}>
            {maintenance.tasks.map(task => (
              <li key={task.id} style={styles.listItem}>{task.name}</li>
            ))}
          </ul>
        </div>
      )}

      {maintenance.notes && maintenance.notes.length > 0 && (
        <div style={styles.section}>
          <div style={styles.sectionTitle}>{t('notes')}</div>
          <ul style={styles.list}>
            {maintenance.notes.map(note => (
              <li key={note.id} style={styles.noteItem}>
                {note.description}
                {note.description_customer && (
                  <div style={{ marginTop: '4px', color: '#6c757d' }}>
                    {t('customerNote')}: {note.description_customer}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}

      {(maintenance.foreman_name_display || maintenance.technician_name_display) && (
        <div style={styles.section}>
          <div style={styles.sectionTitle}>{t('personnel')}</div>
          <ul style={styles.list}>
            {maintenance.foreman_name_display && (
              <li style={styles.personnelItem}>
                <span>{t('foreman')}: {maintenance.foreman_name_display}</span>
              </li>
            )}
            {maintenance.technician_name_display && (
              <li style={styles.personnelItem}>
                <span>{t('technician')}: {maintenance.technician_name_display}</span>
              </li>
            )}
          </ul>
        </div>
      )}

    </div>
  );
};

class ManufacturerServiceBookEntryModal extends React.Component {
  constructor(props) {
    super(props);
    const { maintenance, workshop, manufacturerServiceBookEntry } = props;

    this.state = {
      formData: {
        maintenance_id: maintenance ? maintenance.id : null,
        workshop_id: maintenance ? maintenance.workshop.id : workshop.id,
        data: manufacturerServiceBookEntry && manufacturerServiceBookEntry.form_data
          ? manufacturerServiceBookEntry.form_data
          : {}
      },
      maintenanceDate: manufacturerServiceBookEntry && manufacturerServiceBookEntry.maintenance_date ? manufacturerServiceBookEntry.maintenance_date : null,
      maintenanceKm: manufacturerServiceBookEntry && manufacturerServiceBookEntry.km ? manufacturerServiceBookEntry.km : ''
    };
  }

  handleFormChange = (manufacturerFormData) => {
    const { formData } = this.state;
    this.setState({ formData: { ...formData, data: { ...manufacturerFormData } }});
  };

  handleDateChange = (value) => {
    const { workshop, manufacturerServiceBookEntry } = this.props;
    const d = moment(value).format('YYYY-MM-DD');
    this.setState({ maintenanceDate: d  });
    axios.patch(`/uiapi/1/service-book-entries/${manufacturerServiceBookEntry.id}/?workshop_id=${workshop.id}`, {
      maintenance_date: d,
    }).catch(err => {
      console.error('Failed to save form data:', err);
    });
  };

  handleKmChange = (e) => {
    const { workshop, manufacturerServiceBookEntry } = this.props;
    const km = e.value;
    this.setState({ maintenanceKm: km });
    axios.patch(`/uiapi/1/service-book-entries/${manufacturerServiceBookEntry.id}/?workshop_id=${workshop.id}`, {
      km: km,
    }).catch(err => {
      console.error('Failed to save form data:', err);
    });
  };

  submitForm = () => {
    const { closeModal, maintenance, workshop, manufacturerServiceBookEntry } = this.props;
    const { formData, maintenanceDate, maintenanceKm } = this.state;

    const submitData = {
      ...formData,
      maintenance_date: maintenanceDate,
      maintenance_km: parseInt(maintenanceKm)
    };
    if (maintenance) {
      axios.post('/api/1/integrations/oe/create-dsb-entry/', submitData)
      .then((response) => {
        if (response.data && response.data.url) {
          window.open(response.data.url, '_blank');
        }
        closeModal();
      })
      .catch((error) => {
        console.error(error);
        if (error.response && error.response.data && error.response.data.error) {
          toast.error(error.response.data.error);
        } else {
          toast.error(this.props.t('partnerSystemSaveError'));
        }
      });
    } else {
      delete submitData.maintenance_id;
      submitData.entry_id = manufacturerServiceBookEntry.id;
      axios.post('/api/1/integrations/oe/submit-dsb-entry-without-maintenance/', submitData)
      .then((response) => {
        if (response.data && response.data.url) {
          window.open(response.data.url, '_blank');
        }
        closeModal();
      })
      .catch((error) => {
        console.error(error);
        if (error.response && error.response.data && error.response.data.error) {
          toast.error(error.response.data.error);
        } else {
          toast.error(this.props.t('partnerSystemSaveError'));
        }
      });
    }
  };

  render() {
    const {
      modalIsOpen,
      closeModal,
      afterOpenModal,
      t,
      maintenance,
      vehicle,
      user,
      workshop,
      manufacturerServiceBookEntry,
      selectedWorkshopId
    } = this.props;

    const { maintenanceDate, maintenanceKm } = this.state;
    const isTrialingOE = getCurrentCompany(user, null, selectedWorkshopId, null).is_trialing_oe;

    return (
      <CBMediaQuery>
        {screenSize => (
          <CBModal
            modalIsOpen={modalIsOpen}
            afterOpenModal={afterOpenModal}
            closeModal={closeModal}
            title={t('entryModalTitle')}
            descriptionText={t('entryModalDescription')}
            submitText={t('moveToFinalize')}
            submitForm={this.submitForm}
            isValid={true}
            vehicleText={vehicle.registration_number || ''}
            isPaymentSubmit={!isTrialingOE}
            paymentData={{
              lookup_key: 'manufacturer_service_book_entry',
              registration_number: vehicle.registration_number,
              workshop_id: maintenance ? maintenance.workshop.id : workshop.id,
              maintenance_id: maintenance ? maintenance.id : null,
              entry_id: manufacturerServiceBookEntry ? manufacturerServiceBookEntry.id : null,
              maintenance_date: maintenanceDate,
              maintenance_km: maintenanceKm,
            }}
          >
            <div style={getStyle(screenSize, styles, 'bodyContainer')}>
              {maintenance && <MaintenanceInfoBox maintenance={maintenance} t={t} />}
              <CBLabelAndValueBlack label={t('vehicleVin')} value={vehicle.platform_number} />

              {maintenance ? (
                <>
                  <CBLabelAndValueBlack label={t('maintenanceDate')} value={formatDate(maintenance.pickup_date)} />
                  <CBLabelAndValueBlack label={t('maintenanceKm')} value={parseInt(maintenance.km)} />
                </>
              ) : (
                <>
                  <div style={getStyle(screenSize, styles, 'inputContainer')}>
                    <p className='font-titillium-web-semi-bold' style={getStyle(screenSize, styles, 'inputLabelText')}>
                      {t('maintenanceDate')}
                    </p>
                    <div className='datepicker-container-white-bg'>
                      <CBDatePickerInput
                        displayedDate={maintenanceDate ? moment(maintenanceDate) : null}
                        type='date'
                        dateFormat={finnishDateFormat}
                        changeDate={this.handleDateChange}
                        minDate={manufacturerServiceBookEntry && manufacturerServiceBookEntry.max_age_in_days ? moment().subtract(manufacturerServiceBookEntry.max_age_in_days, 'days') : null}
                        maxDate={moment()}
                      />
                    </div>
                    {manufacturerServiceBookEntry && manufacturerServiceBookEntry.max_age_in_days && (
                      <p style={{ fontSize: '12px', color: '#6c757d', marginTop: '4px' }}>
                        {t('dateRestrictionMessage', { days: manufacturerServiceBookEntry.max_age_in_days })}
                      </p>
                    )}
                  </div>
                  <div style={getStyle(screenSize, styles, 'inputContainer')}>
                    <p className='font-titillium-web-semi-bold' style={getStyle(screenSize, styles, 'inputLabelText')}>
                      {t('maintenanceKm')}
                    </p>
                    <CBInputField
                      name='maintenanceKm'
                      inputStyle={getStyle(screenSize, styles, 'input')}
                      value={maintenanceKm}
                      placeholder=''
                      onChange={this.handleKmChange}
                      type="number"
                    />
                  </div>
                </>
              )}

              <OeDynamicForm
                workshop={maintenance ? maintenance.workshop : workshop}
                vehicle={vehicle}
                manufacturer_service_book_entry={manufacturerServiceBookEntry}
                onChange={this.handleFormChange}
                maintenanceDate
                maintenanceKm
              />
            </div>
          </CBModal>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 32px'
    },
    inputContainer: {
      marginBottom: 16,
    },
    input: {
      backgroundColor: '#ebebeb',
      fontSize: 14,
      textAlign: 'center',
      resize: 'none',
      color: 'black',
      borderRadius: 100,
      height: 40,
      border: 'none',
      width: '100%',
    },
    inputLabelText: {
      color: 'black',
      textAlign: 'center',
    }
  },
  small: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 16px'
    }
  }
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    selectedChainId: state.chain.selectedChainId,
  };
}

export default connect(
  mapStateToProps,
  {}
)(translate('ManufacturerServiceBook')(ManufacturerServiceBookEntryModal));
